import {arrayVariant} from './answer-list.js';

const scoreWrapper = document.querySelector('.bird-data__score');

function addScore () {
  scoreWrapper.style.visibility = 'visible';
}

export {addScore};